<template>
  <el-dialog
    :visible.sync="visibleSync"
    width="760px"
    :show-close="false"
    :modal-append-to-body="false"
    :lock-scroll="false"
    @open="onOpen"
    :title="isEdit ? 'Chỉnh sửa kết quả học viên' : 'Thêm mới kết quả học viên'"
  >
    <ValidationObserver ref="observer">
      <div>
        <div class="row">
          <div class="col-6 mt-3">
            <label>Khách hàng <span class="text-danger">*</span></label>
            <ValidationProvider name="Khách hàng" rules="required" v-slot="{ errors }">
              <el-select
                v-model="form.user_id"
                class="w-100"
                size="small"
                :disabled="isEdit"
                :loading="loadingCustomer"
                :remote-method="remoteMethod"
                clearable
                filterable
                placeholder="Tìm tên, sđt, mã khách hàng"
                remote
                reserve-keyword
              >
                <el-option
                  v-for="user in userOptions"
                  :key="user.id"
                  :label="formatCustomerLabel(user)"
                  :value="user.id"
                />
              </el-select>
              <div class="text-danger mt-1 small" v-if="errors[0]">Khách hàng không được bỏ trống</div>
            </ValidationProvider>
          </div>
          <div class="col-6 mt-3">
            <label>Thời gian thi <span class="text-danger">*</span></label>
            <ValidationProvider
              name="Thời gian thi"
              :rules="isEdit ? '' : 'required'"
              v-slot="{ errors }"
            >
              <el-date-picker
                v-model="form.exam_time"
                size="small"
                type="datetime"
                format="dd-MM-yyyy HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="Chọn thời gian thi"
                class="w-100"
                style="width: 100%"
                clearable
                :disabled="isEdit"
              />
              <div class="text-danger mt-1 small" v-if="errors[0]">Thời gian thi không được bỏ trống</div>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3">
            <label>Điểm Listening <span class="text-danger">*</span></label>
            <ValidationProvider name="Điểm Listening" rules="required" v-slot="{ errors }">
              <el-select v-model="form.listening" size="small" class="w-100" clearable placeholder="Chọn điểm thi">
                <el-option v-for="score in scoreOptions" :key="'l-' + score" :label="score" :value="score" />
              </el-select>
              <div class="text-danger mt-1 small" v-if="errors[0]">Điểm Listening không được bỏ trống</div>
            </ValidationProvider>
          </div>
          <div class="col-6 mt-3">
            <label>Điểm Reading <span class="text-danger">*</span></label>
            <ValidationProvider name="Điểm Reading" rules="required" v-slot="{ errors }">
              <el-select v-model="form.reading" size="small" class="w-100" clearable placeholder="Chọn điểm thi">
                <el-option v-for="score in scoreOptions" :key="'r-' + score" :label="score" :value="score" />
              </el-select>
              <div class="text-danger mt-1 small" v-if="errors[0]">Điểm Reading không được bỏ trống</div>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3">
            <label>Điểm Writing <span class="text-danger">*</span></label>
            <ValidationProvider name="Điểm Writing" rules="required" v-slot="{ errors }">
              <el-select v-model="form.writing" size="small" class="w-100" clearable placeholder="Chọn điểm thi">
                <el-option v-for="score in scoreOptions" :key="'w-' + score" :label="score" :value="score" />
              </el-select>
              <div class="text-danger mt-1 small" v-if="errors[0]">Điểm Writing không được bỏ trống</div>
            </ValidationProvider>
          </div>
          <div class="col-6 mt-3">
            <label>Điểm Speaking <span class="text-danger">*</span></label>
            <ValidationProvider name="Điểm Speaking" rules="required" v-slot="{ errors }">
              <el-select v-model="form.speaking" size="small" class="w-100" clearable placeholder="Chọn điểm thi">
                <el-option v-for="score in scoreOptions" :key="'s-' + score" :label="score" :value="score" />
              </el-select>
              <div class="text-danger mt-1 small" v-if="errors[0]">Điểm Speaking không được bỏ trống</div>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <div slot="footer" class="dialog-footer d-flex justify-content-end">
      <button class="mt-2 btn btn-secondary font-weight-bold mr-2" @click="close">
        Hủy bỏ
      </button>
      <button class="mt-2 btn btn-primary font-weight-bold" :disabled="submitting" @click="confirm">
        <span v-if="!submitting">Xác nhận</span>
        <span v-else>Đang xử lý...</span>
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { SEARCH_CUSTOMER_BY_OR_ID } from '@/core/services/store/user/users.module';
import {
  ENTRANCE_STUDENT_RESULT_CREATE,
  ENTRANCE_STUDENT_RESULT_UPDATE,
} from '@/core/services/store/entrance/entrance.module';

const _ = require('lodash');

const emptyForm = () => ({
  user_id: null,
  exam_time: null,
  listening: null,
  reading: null,
  writing: null,
  speaking: null,
});

export default {
  name: 'StudentExamResultFormModal',
  components: { ValidationObserver, ValidationProvider },
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    record: { type: Object, default: null },
  },
  data() {
    return {
      visibleSync: this.visible,
      form: emptyForm(),
      userSearch: [],
      loadingCustomer: false,
      submitting: false,
      scoreOptions: Array.from({ length: 21 }, (_, i) => i * 0.5),
    };
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    },
    userOptions() {
      if (this.isEdit && this.record?.user_id) {
        const exists = this.userSearch.some((user) => user.id === this.record.user_id);
        if (!exists) {
          return [{
            id: this.record.user_id,
            name: this.record.student_name,
            phone: this.record.phone,
          }, ...this.userSearch];
        }
      }
      return this.userSearch;
    },
  },
  created() {
    extend('required', required);
    this.debouncedSearchCustomer = _.debounce(this.searchCustomer, 300);
  },
  watch: {
    visible(value) {
      this.visibleSync = value;
    },
    visibleSync(value) {
      this.$emit('update:visible', value);
    },
  },
  methods: {
    formatCustomerLabel(user) {
      return `${user.id + 100000} - ${user.name} - ${user.phone}`;
    },
    onOpen() {
      this.resetForm();
      if (this.isEdit && this.record) {
        this.form = {
          user_id: this.record.user_id,
          exam_time: this.record.exam_time,
          listening: this.record.listening,
          reading: this.record.reading,
          writing: this.record.writing,
          speaking: this.record.speaking,
        };
      }
      this.$nextTick(() => {
        this.$refs.observer?.reset();
      });
    },
    resetForm() {
      this.form = emptyForm();
      this.userSearch = [];
      this.submitting = false;
    },
    close() {
      this.visibleSync = false;
    },
    remoteMethod(query) {
      if (query && query.length >= 3) {
        this.loadingCustomer = true;
        this.debouncedSearchCustomer(query);
      } else {
        this.userSearch = [];
      }
    },
    searchCustomer(query) {
      this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, {
        search_customer_by_phoneOrId: query,
        limit: 10000,
        status: 1,
        is_staff: 0,
      }).then((res) => {
        this.userSearch = res.data?.data ?? [];
      }).finally(() => {
        this.loadingCustomer = false;
      });
    },
    buildPayload() {
      const payload = {
        user_id: this.form.user_id,
        result_at: this.form.exam_time,
        listening_score: this.form.listening,
        reading_score: this.form.reading,
        writing_score: this.form.writing,
        speaking_score: this.form.speaking,
      };

      if (this.isEdit) {
        return {
          marking_exam_result_id: this.record.id,
          user_id: payload.user_id,
          listening_score: payload.listening_score,
          reading_score: payload.reading_score,
          writing_score: payload.writing_score,
          speaking_score: payload.speaking_score,
        };
      }

      return payload;
    },
    async confirm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      this.submitting = true;
      const requestPayload = this.buildPayload();
      const action = this.isEdit
        ? ENTRANCE_STUDENT_RESULT_UPDATE
        : ENTRANCE_STUDENT_RESULT_CREATE;

      try {
        const res = await this.$store.dispatch(action, requestPayload);
        this.$message.success(res.message || (this.isEdit ? 'Cập nhật thành công' : 'Tạo thành công'));
        this.$emit('saved');
        this.close();
      } catch (error) {
        this.$message.error(error?.message || 'Có lỗi xảy ra');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
